import Grid from "@material-ui/core/Grid";
import React from "react";
import ChartContainer from "./ChartContainer";
import RecentTransports from "./RecentTransports";

export default function Dashboard(props) {
  return (
    <Grid container spacing={3}>
      {/* Chart */}
      <ChartContainer />
      {/* Recent Transports */}
      <RecentTransports />
    </Grid>
  );
}
